import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import React, { useEffect, useRef } from 'react';

interface MapboxGeocoderInputProps {
  value: string;
  onSelect: (placeName: string, lat: number, lng: number) => void;
  placeholder?: string;
}

const MapboxGeocoderInput: React.FC<MapboxGeocoderInputProps> = ({
  value,
  onSelect,
  placeholder = 'Search location...',
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const geocoderRef = useRef<MapboxGeocoder | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const geocoder = new MapboxGeocoder({
      accessToken: process.env.REACT_APP_MAPBOX_TOKEN!,
      types: 'place,postcode,locality',
      placeholder,
    });

    geocoder.addTo(containerRef.current);

    geocoder.on('result', (e) => {
      const [lng, lat] = e.result.center;
      onSelect(e.result.place_name, lat, lng);
    });

    geocoderRef.current = geocoder;

    return () => {
      geocoder.onRemove();
    };
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
      }}
    />
  );
};

export default MapboxGeocoderInput;
